import {useEffect, useState} from 'react';
import styles from './styles.module.css';

const SoopiBorder = () => {
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsActive(false);
      setTimeout(() => {
        setIsActive(true);
      }, 3000); 
    }, 10000); 
    return () => clearInterval(interval); 
  }, []);
  return (
    <div
      className={`${styles.outerBorder} ${isActive && styles.rotateAnimation}`}
    />
  );
};

export default SoopiBorder;